import { defineMessages } from 'react-intl-next';

import { type TypeFilterValueKey } from '../../../../../common/constants/filters/universal-type';

export const typeLabels: Record<
	TypeFilterValueKey | 'all' | 'pageAndLiveDoc',
	import('react-intl-next').MessageDescriptor
> = defineMessages<TypeFilterValueKey | 'all' | 'pageAndLiveDoc'>({
	all: {
		id: 'search-page.filter.type.all',
		defaultMessage: 'All',
		description: 'All filter type',
	},
	position: {
		id: 'search-page.filter.type.position',
		defaultMessage: 'Positions',
		description: 'Position filter type',
	},
	document: {
		id: 'search-page.filter.type.documents',
		defaultMessage: 'Documents',
		description: 'Document filter type',
	},
	spreadsheet: {
		id: 'search-page.filter.type.spreadsheet',
		defaultMessage: 'Spreadsheets',
		description: 'Spreadsheets filter type',
	},
	presentation: {
		id: 'search-page.filter.type.presentation',
		defaultMessage: 'Presentations',
		description: 'Presentations filter type',
	},
	repository: {
		id: 'search-page.filter.type.repository',
		defaultMessage: 'Repositories',
		description: 'Repository filter type',
	},
	'pull-request': {
		id: 'search-page.filter.type.pull-request',
		defaultMessage: 'Pull requests',
		description: 'Pull request filter type',
	},
	branch: {
		id: 'search-page.filter.type.branch',
		defaultMessage: 'Branches',
		description: 'Branch filter type',
	},
	commit: {
		id: 'search-page.filter.type.commit',
		defaultMessage: 'Commits',
		description: 'Commit filter type',
	},
	conversation: {
		id: 'search-page.filter.type.conversation',
		defaultMessage: 'Channels',
		description: 'Channels filter type',
	},
	message: {
		id: 'search-page.filter.type.message',
		defaultMessage: 'Messages',
		description: 'Message filter type',
	},
	video: {
		id: 'search-page.filter.type.video',
		defaultMessage: 'Videos',
		description: 'Video filter type',
	},
	design: {
		id: 'search-page.filter.type.design',
		defaultMessage: 'Designs',
		description: 'Design filter type',
	},
	pageAndLiveDoc: {
		id: 'search-page.filter.type.pageAndLiveDoc',
		defaultMessage: 'Pages and Live Docs',
		description: 'Page and Live Docs filter type',
	},
	page: {
		id: 'search-page.filter.type.page',
		defaultMessage: 'Pages',
		description: 'Page filter type',
	},
	blogpost: {
		id: 'search-page.filter.type.blogpost',
		defaultMessage: 'Blog posts',
		description: 'Blog posts filter type',
	},
	attachment: {
		id: 'search-page.filter.type.attachment',
		defaultMessage: 'Attachments',
		description: 'Attachment filter type',
	},
	space: {
		id: 'search-page.filter.type.space',
		defaultMessage: 'Spaces',
		description: 'Space filter type',
	},
	whiteboard: {
		id: 'search-page.filter.type.whiteboard',
		defaultMessage: 'Whiteboards',
		description: 'Whiteboard filter type',
	},
	issue: {
		id: 'search-page.filter.type.jira-work-item',
		defaultMessage: 'Work items',
		description: 'Work item filter type',
	},
	project: {
		id: 'search-page.filter.type.project',
		defaultMessage: 'Projects',
		description: 'Project filter type',
	},
	goal: {
		id: 'search-page.filter.type.goal',
		defaultMessage: 'Goals',
		description: 'Goal filter type',
	},
	tag: {
		id: 'search-page.filter.type.tag',
		defaultMessage: 'Tags',
		description: 'tag filter type',
	},
	'web-page': {
		id: 'search-page.filter.type.web-page',
		defaultMessage: 'Web pages',
		description: 'Webpage filter type',
	},
	comment: {
		id: 'search-page.filter.type.comment',
		defaultMessage: 'Comments',
		description: 'Comment filter type',
	},
	database: {
		id: 'search-page.filter.type.database',
		defaultMessage: 'Databases',
		description: 'Database filter type',
	},
	embed: {
		id: 'search-page.filter.type.embed',
		defaultMessage: 'Smart Links',
		description: 'Smart Link filter type',
	},
	folder: {
		id: 'search-page.filter.type.folder',
		defaultMessage: 'Folders',
		description: 'Folder filter type',
	},
	calendar: {
		id: 'search-page.filter.type.calendar',
		defaultMessage: 'Calendars',
		description: 'Calendars filter type',
	},
	'space-calendar': {
		id: 'search-page.filter.type.space-calendar',
		defaultMessage: 'Space calendars',
		description: 'Space calendars filter type',
	},
	answer: {
		id: 'search-page.filter.type.answer',
		defaultMessage: 'Answers',
		description: 'Answers filter type',
	},
	question: {
		id: 'search-page.filter.type.question',
		defaultMessage: 'Questions',
		description: 'Questions filter type',
	},
	component: {
		id: 'search-page.filter.type.component',
		defaultMessage: 'Components',
		description: 'Component filter type',
	},
	'work-item': {
		id: 'search-page.filter.type.work-item',
		defaultMessage: 'Tasks',
		description: 'Work item filter type',
	},
	card: {
		id: 'search-page.filter.type.card',
		defaultMessage: 'Cards',
		description: 'Card filter type',
	},
	incident: {
		id: 'search-page.filter.type.incident',
		defaultMessage: 'Incidents',
		description: 'Incident filter type',
	},
	'focus-area': {
		id: 'search-page.filter.type.focus-area',
		defaultMessage: 'Focus areas',
		description: 'Focus areas filter type',
	},
	ask: {
		id: 'search-page.filter.type.ask',
		defaultMessage: 'Asks',
		description: 'Ask filter type',
	},
	dashboard: {
		id: 'search-page.filter.type.dashboard',
		defaultMessage: 'Dashboards',
		description: 'Dashboard filter type',
	},
	invoice: {
		id: 'search-page.filter.type.invoice',
		defaultMessage: 'Invoices',
		description: 'Invoice filter type',
	},
	deal: {
		id: 'search-page.filter.type.deal',
		defaultMessage: 'Deals',
		description: 'Deal filter type',
	},
	gliffy: {
		id: 'search-page.filter.type.gliffy',
		defaultMessage: 'Gliffy Diagrams',
		description: 'Gliffy filter type',
	},
	'customer-contact': {
		id: 'search-page.filter.type.customer-contact',
		defaultMessage: 'Customer Contacts',
		description: 'Customer Contact filter type',
	},
	'customer-org': {
		id: 'search-page.filter.type.customer-org',
		defaultMessage: 'Customer Organizations',
		description: 'Customer Organization filter type',
	},
	board: {
		id: 'search-page.filter.type.board',
		defaultMessage: 'Boards',
		description: 'Board filter type',
	},
	plan: {
		id: 'search-page.filter.type.plan',
		defaultMessage: 'Plans',
		description: 'Plan filter type',
	},
	filter: {
		id: 'search-page.filter.type.filter',
		defaultMessage: 'Filters',
		description: 'Filter filter type',
	},
	'data-table': {
		id: 'search-page.filter.type.data-table',
		defaultMessage: 'Data tables',
		description: 'Data table filter type',
	},
	object: {
		id: 'search-page.filter.type.object',
		defaultMessage: 'Objects',
		description: 'Object filter type',
	},
	schema: {
		id: 'search-page.filter.type.schema',
		defaultMessage: 'Schemas',
		description: 'Assets schema filter type',
	},
	type: {
		id: 'search-page.filter.type.type',
		defaultMessage: 'Object types',
		description: 'Object type filter type',
	},
	epic: {
		id: 'search-page.filter.type.epic',
		defaultMessage: 'Epic',
		description: 'Jira Epic work type',
	},
	bug: {
		id: 'search-page.filter.type.bug',
		defaultMessage: 'Bug',
		description: 'Jira Bug work type',
	},
	story: {
		id: 'search-page.filter.type.Story',
		defaultMessage: 'Story',
		description: 'Jira Story work type',
	},
	task: {
		id: 'search-page.filter.type.task',
		defaultMessage: 'Task',
		description: 'Jira task work type',
	},
	subtask: {
		id: 'search-page.filter.type.subtask',
		defaultMessage: 'Subtask',
		description: 'Jira Subtask work type',
	},
	image: {
		id: 'search-page.filter.type.image',
		defaultMessage: 'Images',
		description: 'Image filter type',
	},
	audio: {
		id: 'search-page.filter.type.audio',
		defaultMessage: 'Audio',
		description: 'Audio filter type',
	},
	pdf: {
		id: 'search-page.filter.type.pdf',
		defaultMessage: 'PDF',
		description: 'PDF filter type',
	},
	shortcut: {
		id: 'search-page.filter.type.shortcut',
		defaultMessage: 'Shortcut',
		description: 'Shortcut filter type',
	},
	code: {
		id: 'search-page.filter.type.code',
		defaultMessage: 'Code',
		description: 'Code filter type',
	},
	archive: {
		id: 'search-page.filter.type.archive',
		defaultMessage: 'Archive',
		description: 'Archive filter type',
	},
	form: {
		id: 'search-page.filter.type.form',
		defaultMessage: 'Form',
		description: 'Form filter type',
	},
	notebook: {
		id: 'search-page.filter.type.notebook',
		defaultMessage: 'Notebook',
		description: 'Notebook filter type',
	},
	other: {
		id: 'search-page.filter.type.other',
		defaultMessage: 'Other',
		description: 'Other filter type',
	},
	article: {
		id: 'search-page.filter.type.article',
		defaultMessage: 'Articles',
		description: 'Article filter type',
	},
	post: {
		id: 'search-page.filter.type.post',
		defaultMessage: 'Posts',
		description: 'Post filter type',
	},
	ticket: {
		id: 'search-page.filter.type.ticket',
		defaultMessage: 'Tickets',
		description: 'Ticket filter type',
	},
	campaign: {
		id: 'search-page.filter.type.campaign',
		defaultMessage: 'Campaigns',
		description: 'Campaign filter type',
	},
	case: {
		id: 'search-page.filter.type.case',
		defaultMessage: 'Cases',
		description: 'Case filter type',
	},
});
